module.exports = __webpack_public_path__ + "media/extro.6e7a7362.mp3";